export const GLOBAL_LAYOUT_UPDATE_DISPLAY_SETTINGS =
  'REPORTING_GLOBAL_LAYOUT_UPDATE_DISPLAY_SETTINGS';

export const updateDisplaySettings = newData => ({
  type: GLOBAL_LAYOUT_UPDATE_DISPLAY_SETTINGS,
  newData,
});
